import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import NamedValuesService from '../../../services/NamedValues.service'

export const useDeleteNamedValue = () => {
  const queryClient = useQueryClient()
  const { org } = useParams()

  return useMutation<any, Error, { id: string }>({
    mutationKey: ['delete-named-value'],
    mutationFn: (payload) => NamedValuesService.deleteNamedValue(org!, payload.id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['named-values'] })
    },
  })
}
